import React from 'react';
import ReactDOM from 'react-dom/client';
// import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router} from "react-router-dom";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


/*
SmartLuggage Application
Marek Augustyn
12 May 2022
Final Project Software Developer
*/

//React 17
// ReactDOM.render(
//
//   <React.StrictMode>
//       {/*//router collect info about paths etc*/}
//       <Router>
//           <App />
//       </Router>
//
//   </React.StrictMode>
//   ,
//   document.getElementById('root')
// );

//New React version
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* Provider allows access to variable in all components */}
        {/*<Provider store = {store}>*/}
        <Router>
            <App />
        </Router>

        {/*</Provider>*/}

    </React.StrictMode>

);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
